import styled from 'styled-components'

export const HorizontalContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${props => `${props.theme.marginXXS}px`};
`
